var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staking-detail pool" },
    [
      _c("div", { staticClass: "item pool" }, [
        _c("span", { staticClass: "icon" }),
        _vm._v(" "),
        _c("div", { staticClass: "token-wrapper" }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("tradeDividend.allPrice")))]),
          _vm._v(" "),
          _c("div", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.allBtc))]),
          _vm._v(" "),
          _c("div", { staticClass: "light" }, [_vm._v(_vm._s(_vm.allPrice))])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.typeList, function(tokenType) {
        return [
          tokenType.name !== "dSLS"
            ? _c("div", { key: tokenType.name, staticClass: "pool item" }, [
                _c("img", {
                  staticClass: "icon",
                  attrs: { src: tokenType.icon }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.hideTokenList,
                        expression: "hideTokenList"
                      }
                    ],
                    staticClass: "token-wrapper __pointer",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.showTokenList(tokenType)
                      }
                    }
                  },
                  [
                    _c("div", [_vm._v(_vm._s(tokenType.name))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "bold" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.pool[tokenType.name]
                              ? _vm.formatNum(
                                  _vm.pool[tokenType.name].amount,
                                  tokenType.name
                                )
                              : "--"
                          ) +
                          "\n                    "
                      ),
                      _c("span", { staticClass: "down-icon" })
                    ]),
                    _vm._v(" "),
                    _vm.pool[tokenType.name] &&
                    _vm.isShowTokenList === tokenType.name
                      ? _c(
                          "div",
                          { staticClass: "item-content" },
                          _vm._l(_vm.pool[tokenType.name].tokens, function(
                            token,
                            i
                          ) {
                            return _c("div", { key: i, staticClass: "row" }, [
                              _c("span", { staticClass: "light" }, [
                                _vm._v(
                                  _vm._s(_vm.getSymbol(token.tokenInfo)) + ":"
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "amount" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNum(token.amount, tokenType.name)
                                  )
                                )
                              ])
                            ])
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                )
              ])
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }